
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/new/[index]",
      function () {
        return require("private-next-pages/products/new/[index].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/new/[index]"])
      });
    }
  